import React from "react";

import api from "../../store/api/api";
import { stripCountrySuffix } from "./formatAddress";
import TurfDropoffMapModalBase from "./TurfDropoffMapModalBase";

// biases the places search around the canvasser's assigned turf so results are relevant, not just global
const ADDRESS_SEARCH_RADIUS_METERS = 3200;

// google documentation for text search and geographic bias:
// https://developers.google.com/maps/documentation/places/web-service/search-text
// (legacy has no notion of a turf `boundary` -- it only ever gets a `center` for
// the location bias, unlike the uber path which can also filter to a polygon)
const searchAddresses = (query, options = {}) => {
  const { center } = options;
  const params = { address: query };
  if (center) {
    params.location = `${center.lat.toFixed(5)}%2C${center.lon.toFixed(5)}`;
    params.radius = ADDRESS_SEARCH_RADIUS_METERS;
  }

  return api.get("/geocode_places", params).then((res) => {
    const results = (res.data && res.data.results) || [];
    return results.map((r) => ({
      key: r.place_id,
      primary: r.name || r.formatted_address,
      secondary: r.name ? r.formatted_address : null,
      fullAddress: stripCountrySuffix(r.formatted_address),
      lat: r.geometry.location.lat,
      lon: r.geometry.location.lng,
    }));
  });
};

const TurfDropoffMapModalLegacy = (props) => (
  <TurfDropoffMapModalBase {...props} searchAddresses={searchAddresses} />
);

export default TurfDropoffMapModalLegacy;
